export class Descuento_Monto {
   constructor(id, min_compra, max_compra, porcentaje, descuento, fecha_inicio, fecha_fin, segmentos_no_aplica, tipo_regla){
      this.id = id
      this.min_compra = min_compra
      this.max_compra = max_compra
      this.porcentaje = porcentaje
      this.descuento = descuento
      this.fecha_inicio = fecha_inicio
      this.fecha_fin = fecha_fin
      this.segmentos_no_aplica = segmentos_no_aplica
      this.tipo_regla = tipo_regla
   } 

   static fromServiceDescuentoPorMonto (descuentoMonto) {
      return new Descuento_Monto(
         descuentoMonto.ID,
         descuentoMonto.Min_Compra,
         descuentoMonto.Max_Compra,
         descuentoMonto.Porcentaje,
         descuentoMonto.Descuento,
         descuentoMonto.Fecha_Inicio,
         descuentoMonto.Fecha_Fin,
         descuentoMonto.SegmentosNoAplica,
         descuentoMonto.Tipo_Regla
         );
   }
}